export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full">
              <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20colorful%20manga%20and%20comic%20books%20displayed%20on%20wooden%20shelves%2C%20warm%20ambient%20lighting%20from%20a%20desk%20lamp%2C%20comfortable%20armchair%2C%20cream%20walls%2C%20inviting%20atmosphere%2C%20editorial%20photography%20style%2C%20soft%20and%20clean%20aesthetic&width=800&height=600&seq=about-platform&orientation=landscape"
                  alt="亲亲漫画 - 免费漫画在线阅读平台介绍"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="flex-1 w-full">
              <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
                <i className="ri-information-line text-sm"></i>
                关于我们
              </div>
              <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-5">
                关于亲亲漫画
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  亲亲漫画网是国内领先的免费漫画在线阅读平台，致力于为广大漫画爱好者提供最便捷、最丰富的漫画阅读体验。平台涵盖韩漫、日漫、国漫三大品类，汇集了超过十万部优质漫画作品。
                </p>
                <p>
                  我们采用先进的下拉式阅读技术，完美适配手机、平板和电脑端，读者只需轻滑屏幕即可畅享沉浸式漫画之旅。全本完整版漫画免注册免费开放，每日实时更新热门连载，让追更不再等待。
                </p>
                <p>
                  亲亲漫画坚持"内容为王、读者至上"的理念，持续扩充漫画库，优化阅读体验。无论你是喜欢浪漫甜宠、热血冒险、悬疑推理还是奇幻玄幻，这里都有你想要的精彩故事。
                </p>
              </div>
              <div className="flex flex-wrap gap-4 mt-7">
                <div className="flex items-center gap-3 px-4 py-3 bg-background-100 rounded-xl">
                  <div className="text-2xl font-extrabold text-primary-600">10万+</div>
                  <div className="text-xs text-foreground-500">收录作品</div>
                </div>
                <div className="flex items-center gap-3 px-4 py-3 bg-background-100 rounded-xl">
                  <div className="text-2xl font-extrabold text-accent-600">200+</div>
                  <div className="text-xs text-foreground-500">每日更新话数</div>
                </div>
                <div className="flex items-center gap-3 px-4 py-3 bg-background-100 rounded-xl">
                  <div className="text-2xl font-extrabold text-secondary-600">500万+</div>
                  <div className="text-xs text-foreground-500">活跃读者</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}